import { css } from 'styled-components';
import {
  getSpacing, getTypography, rgba, SpacingName, ThemedFunctor, TypographyName,
} from '@doveit/lego';

export const main: ThemedFunctor = ({
  theme,
  $visible,
  $hiddenFrom,
}) => css`
  ${getSpacing.padding(theme, SpacingName.SMALL)}
  background-color: ${rgba(theme.palettes.neutrals.lightest, 0.9)};
  box-shadow: 0 -2px 10px rgba(0,0,0,0.2);
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  text-align: center;
  transform: translateY(${$visible ? '0' : '100%'});
  transition: transform ease-out .4s;
  will-change: transform;
  z-index: ${theme.zIndex.inpage};

  ${$hiddenFrom && `
    ${theme.breakpoints.up($hiddenFrom)} {
      display: none;
    }
  `}
`;

export const title: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.BODY)}
  ${getSpacing.marginBottom(theme, SpacingName.SMALLER)}
`;
